<template>
  <div class="component-content">
    <div class="component-header">
      <a-row style="width: 100%">
        <a-col :span="4">
          <div style="width: 44px; height: 44px">
            <img
              :src="componentWhiteImg"
              style="width: 100%; height: 100%; margin-top: 5px;cursor: pointer;"
              alt=""
            />
          </div>
        </a-col>
        <a-col :span="10" style="height: 90%"
          ><div class="component-header-text">默认组件</div></a-col
        >
      </a-row>
    </div>
    <div class="divideLine" />
    <!-- 默认展示 -->
    <div class="default-component">
      <div style="width: 100%">
        <a-collapse :bordered="false" expandIconPosition="right">
          <a-collapse-panel
            v-for="(project, index) in defaultComponentList"
            :key="index"
            :header="project.name"
            forceRender
          >
            <div ref="showComponent" class="show-component">
              <div
                style="display: inline-block;"
                class="component-item"
                :id="component.id"
                :key="index"
                v-for="(component, index) in project.componentList"
              >
                <Popover :component="component" />
                <div class="component-item-name">{{ component.title }}</div>
              </div>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import Popover from "@/views/edit-page/popover/Popover.vue";
import builtinJson from "@/components/built-in/builtin-config.json"
import { v4 as uuidv4 } from 'uuid';

export default {
  data() {
    return {
      componentWhiteImg: require("@/assets/edit-page/componentWhite.png"),
      defaultComponentList: builtinJson
    };
  },
  components: {
    Popover,
  },
  created(){
    this.initComponentList()
    this.initSortables()
  },
  methods: {
    /**
     * 获取componetList
     */
    initComponentList(){
      let componentList = []
      _.each(this.defaultComponentList, group => {
        _.each(group.componentList, comp => {
          Object.assign(comp, {id: uuidv4()})
          componentList.push(comp)
        })
      })
      this.$emit("setComponentList", componentList)
    },
    /**
     * 初始化Sortables
     */
    initSortables(){
      this.$nextTick(() => {
        var els = this.$refs.showComponent;
        this.$emit('createSortables', els)
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "./defaultComponent.css";
</style>